import {
  createBrowserRouter,
  Navigate,
} from 'react-router-dom';
import { Lazy, RequireAuth } from './utils';
import { ProtectedRoute } from './ProtectedRoute';

const router = createBrowserRouter([
  /* unauthenticated */
  { path: '/login', element: Lazy(() => import('../pages/Login')) },
  { path: '/signup', element: Lazy(() => import('../pages/Signup')) },
  { path: '/activate/:token', element: Lazy(() => import('../pages/Activate')) },
  { path: '/forgot-password', element: Lazy(() => import('../pages/ForgotPassword')) },
  { path: '/reset-password', element: Lazy(() => import('../pages/ResetPassword')) },

  /* authenticated – wrapped in RequireAuth */
  {
    element: <RequireAuth />,
    children: [
      { index: true, element: <Navigate to="/babies" replace /> },
      { path: '/devices', element: Lazy(() => import('../pages/Devices')) },
      { path: '/devices/:id', element: Lazy(() => import('../pages/DeviceDetail')) },
      { path: '/babies', element: Lazy(() => import('../pages/Babies')) },
      { path: '/babies/:id', element: Lazy(() => import('../pages/BabyDetail')) },
      { path: '/map', element: Lazy(() => import('../pages/Map')) },

      // Routes that require edit permissions (protected from emergency contacts)
      {
        path: '/emergency-contacts',
        element: (
          <ProtectedRoute requireEdit>
            {Lazy(() => import('../pages/EmergencyContacts'))}
          </ProtectedRoute>
        )
      },
      {
        path: '/register-childminder-monitor',
        element: (
          <ProtectedRoute requireEdit>
            {Lazy(() => import('../pages/RegisterChildminderMonitor'))}
          </ProtectedRoute>
        )
      },
      {
        path: '/register-environment-monitor',
        element: (
          <ProtectedRoute requireEdit>
            {Lazy(() => import('../pages/RegisterEnvironmentMonitor'))}
          </ProtectedRoute>
        )
      },

      { path: '*', element: <Navigate to="/babies" replace /> }, // catch-all
    ],
  },
]);

export { router };
